import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import { Helmet } from "react-helmet-async";
import OptionChainModal from "../../modals/OptionChainModal";
import AnalyseModal from "../../modals/AnalyseModal";
import axios, { all } from "axios";
import BuySellModal from "../../modals/BuySellModal";
import ABWebSocketContext from "../../context/ABWebsocketContext";
import { getSymbols } from "../../utils/api";
import { useGraphContext } from "../../context/GraphContext";
import { toast } from "react-toastify";
import CustomToastContent from "../../components/CustomToastContent";
import { Link } from "react-router-dom";
import { useFundsData } from "../../context/FundsDataContext";
// import positionsData from "../../utils/positionsData.json"
import PositionMetricsComputations from "../../components/PositionMetricsComputations";
import { useBuySellModalContext } from "../../context/BuySellModalContext";
import SuccessIcon from "../../images/success_icon.svg";
import InfoIcon from "../../images/info_icon.svg";
import { useTheme } from "../../context/ThemeContext";
import { Tooltip as ReactTooltip } from "react-tooltip";
import QuestionMark from "../../images/QuestionMark";
import WebsocketWrapperContext from "../../context/WebsocketWrapperContext";
import OverallCard from "./components/OverallCard";
import PositionsInfo from "./components/PositionsInfo";
import { formatNumberWithFontWeight } from "./helpers/formatNumberWithFontWeight";
import UnderlyingGroupView from "./components/UnderlyingGroupView";
import ExecutedStrategiesView from "./components/ExecutedStrategiesView";
import WatchlistContainer from "../../components/watchlist/WatchlistContainer";
import ConfirmStrategyModal from "../StrategyCreator/components/ComfirmModal";
import { getCookie } from "../../utils/cookieUtils";

const access_token = getCookie("access_token");
const client_id = getCookie("client_id");
const broker = localStorage.getItem("broker");

let triggerSubscribe = true;
let connectionEstablised = false;

const PositionsDesktop = () => {
  const { theme } = useTheme();
  const [activeButton, setActiveButton] = useState("groupbyunderlying");
  // This useEffect will be executed once when the component mounts
  const [metrics, setMetrics] = useState({
    total_positions: 0,
    open_positions: 0,
  });
  const { buySellModalData, addToBuySellModal, setBuySellModalData } =
    useBuySellModalContext();
  const [nsesubscribeSymbols, setNSESubscribeSymbols] = useState({});
  const [nfosubscribeSymbols, setNFOSubscribeSymbols] = useState({});
  const [bsesubscribeSymbols, setBSESubscribeSymbols] = useState({});
  const [mcxsubscribeSymbols, setMCXSubscribeSymbols] = useState({});
  const [mcxunderlyingsubscribeSymbols, setMCXUnderlyingSubscribeSymbols] = useState({});
  const [bfosubscribeSymbols, setBFOSubscribeSymbols] = useState({});
  const [allPositions, setAllPositions] = useState([]);
  const [strategyBased, setStrategyBased] = useState([]);
  const [underlyingBased, setUnderlyingBased] = useState([]);
  const [symbols, setSymbols] = useState([]);
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const [netProfit, setNetProfit] = useState(0);
  const metricsComputations = PositionMetricsComputations();
  const [visibility, setVisibility] = useState(true);
  const [pendingProfit, setPendingProfit] = useState(0);
  const [potentialProfit, setPotentialProfit] = useState(0);
  const [potentialLoss, setPotentialLoss] = useState(0);
  const [achievedPercent, setAchievedPercent] = useState(0);
  const [mainIndex, setMainIndex] = useState(null);
  const [duplicateData, setDuplicateData] = useState([]);
  // const [totalMaxProfit, setTotalMaxProfit] = useState(0);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState({ location: null, index: null });

  const showToast = (location, index) => {

    setSelectedPosition({ location, index });
    setShowConfirm(true);
  };

  const handleRowMouseEnter = (row_index, index) => {
    setVisibility(true);
    setHoveredRowIndex(row_index);
    setMainIndex(index);
  };

  const handleRowMouseLeave = () => {
    setVisibility(false);
    setHoveredRowIndex(null);
    setMainIndex(null);
  };

  const [modalData, setModalData] = useState(null);
  const handleClick = (data) => {
    setModalData(data);
  };

  let totalMaxLoss = 0;

  const {
    updateSymbolList,
    websocketConnection,
    checkWebsocketConnection,
    subscribeToSymbols,
    unsubscribeToSymbols,
    symbolList,
    symbolData,
  } = useContext(WebsocketWrapperContext);

  const { fundsData } = useFundsData();

  const [isFetching, setIsFetching] = useState(false);
  const [hadPositions, setHadPositions] = useState(false);

  useEffect(() => {
    fetchPositions();
  }, []);



  useLayoutEffect(() => {
    if ((buySellModalData?.length == 0) & (allPositions?.length > 0)) {
      fetchPositions();
    }
  }, [buySellModalData]);

  const fetchPositions = async () => {
    const apiEndpoint = `https://y0tp4rr2a5.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_positions`;
    const body = {
      access_token: access_token,
      broker: broker,
      client_id: client_id,
    };
    try {
      setIsFetching(true);
      const response = await axios.post(apiEndpoint, body);
      
      if (response.data?.nse_subscribe_symbols) {
        setNSESubscribeSymbols(response.data?.nse_subscribe_symbols);
        setNFOSubscribeSymbols(response.data?.nfo_subscribe_symbols);
        setMetrics(response.data?.metrics);
      }
      if (response.data?.bse_subscribe_symbols) {
        setBSESubscribeSymbols(response.data?.bse_subscribe_symbols);
        setBFOSubscribeSymbols(response.data?.bfo_subscribe_symbols);
      }
      if (response.data?.mcx_subscribe_symbols) {
        setMCXSubscribeSymbols(response.data?.mcx_subscribe_symbols);
        setMCXUnderlyingSubscribeSymbols(response.data?.mcx_underlying_subscribe_symbols);
      }
      setAllPositions(response.data.all_positions);
      const symbols = await getSymbols();
      setSymbols(symbols);
      setUnderlyingBased(response?.data.groupby_underlying);
      setStrategyBased(response?.data.groupby_strategy);
    } catch (error) {
      console.error("Error fetching positions:", error);
    }
    finally {
      setIsFetching(false);
    }
  };

  const exitPositions = async (positions) => {
    const apiEndpoint =
      "https://snji3aqoq9.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_exitpositions";
    const body = {
      access_token: access_token,
      broker: broker,
      client_id: client_id,
      positions: positions,
    };
    try {
      const response = await axios.post(apiEndpoint, body);
      if (response?.data.status) {
        // Clear selected states for all positions
        setUnderlyingBased(prevPositions =>
          prevPositions.map(group => ({
            ...group,
            positions: group.positions.map(position => ({
              ...position,
              selected: false // Clear all selections
            }))
          }))
        );

        setStrategyBased(prevPositions =>
          prevPositions.map(group => ({
            ...group,
            positions: group.positions.map(position => ({
              ...position,
              selected: false // Clear all selections
            }))
          }))
        );

        // Reset all exit button states
        setIsExitSelectedEnabledUnderlying(new Array(underlyingBased.length).fill(false));
        setIsExitSelectedEnabledExecutedStrategies(new Array(strategyBased.length).fill(false));

        // Refetch positions without clearing arrays to avoid flicker
        fetchPositions();

        toast.success(
          <CustomToastContent
            heading={response.data.message_header}
            message={response.data.message_body}
          />,
          {
            className: "custom-success-toast",
            icon: <img src={SuccessIcon} alt="Success Icon" />,
          }
        );
      } else {
        toast.error(
          <CustomToastContent
            heading={response.data.message_header}
            message={response.data.message_body}
          />,
          {
            className: "custom-error-toast",
            icon: <img src={InfoIcon} alt="Success Icon" />,
          }
        );
      }
    } catch (error) {
      console.error("Error exiting positions:", error);
    }
  };

  useEffect(() => {
    const runComputations = async () => {
      if (underlyingBased.length > 0 && Object.keys(symbolData).length > 0) {
        await computeCardMetrics(underlyingBased, "underlying");
      }

      if (strategyBased.length > 0 && Object.keys(symbolData).length > 0) {
        await computeCardMetrics(strategyBased, "strategy");
      }
    };

    runComputations();
  }, [underlyingBased, strategyBased, symbolData]);

  useEffect(() => {
    let temp = [];
    for (let i = 0; i < underlyingBased.length; i++) {
      let temp1 = [];
      for (let j = 0; j < underlyingBased[i].positions.length; j++) {
        temp1.push({ ...underlyingBased[i].positions[j] });
      }
      // Sort temp1 array
      temp1.sort((a, b) => {
        if (a.net_quantity === 0 && b.net_quantity === 0) {
          return 0;
        } else if (a.net_quantity === 0) {
          return 1;
        } else if (b.net_quantity === 0) {
          return -1;
        } else {
          return a.net_quantity - b.net_quantity;
        }
      });
      temp.push(temp1);
    }
    setDuplicateData(temp);
  }, [underlyingBased]);

  // Track if the user has ever had positions in this session
  useEffect(() => {
    if (!hadPositions && (underlyingBased?.length > 0 || strategyBased?.length > 0)) {
      setHadPositions(true);
    }
  }, [underlyingBased, strategyBased, hadPositions]);

  const handleCallback = async () => {
    setModalData();
  };
  const computeCardMetrics = async (group_data, type) => {
    const waitForLTP = async (code, exchange, timeout = 5000) => {
      return new Promise((resolve) => {
        const startTime = Date.now();

        const checkLTP = () => {
          if (symbolData[code]?.ltp !== undefined) {
            resolve(symbolData[code].ltp);
          } else if (Date.now() - startTime > timeout) {
            // console.log(`Timeout waiting for LTP for ${code}`);
            resolve(null); // Resolve with null after timeout
          } else {
            setTimeout(checkLTP, 100);
          }
        };
        checkLTP();
      });
    };

    if (type === "underlying") {
      let totalMaxLoss = 0;
      let totalMaxProfit = 0;
      let hasUnlimitedLoss = false;
      let hasUnlimitedProfit = false;
      let processedItems = 0;

      // Always recalculate for all items since WS data updates
      for (let i = 0; i < group_data.length; i++) {
        let data = group_data[i];

        // Always recalculate since LTP changes
        const ltp = await waitForLTP(data?.code, data?.exchange);

        if (ltp) {
          const computedData = metricsComputations.computeXandYAxis({
            selectedData: data?.positions,
            ltp: ltp,
            leastExpiry: null,
          });
          // Update the data object
          data.breakeven = computedData?.breakevenRange;
          let resp = calculatePointerPosition(
            computedData?.greenRange,
            computedData
          );
          data.greenBarWidth = resp?.width;
          data.leftSpace = resp?.leftSpace;
          data.pointerPosition = resp?.pointerPosition;
          data.x_axis = computedData?.x_axis;
          data.barType = resp?.barType;
          data.maxProfit = computedData?.maxProfit;
          data.maxLoss = computedData?.maxLoss;
          data.computedData = computedData;

          group_data[i] = data;

          // Only accumulate if we have valid computed data
          if (computedData) {
            processedItems++;

            // Handle maxLoss accumulation
            if (computedData.maxLoss === "Unlimited") {
              hasUnlimitedLoss = true;
            } else if (computedData.maxLoss !== undefined && computedData.maxLoss !== null && typeof computedData.maxLoss === 'number') {
              if (!hasUnlimitedLoss) {
                totalMaxLoss += computedData.maxLoss;
              }
            }

            // Handle maxProfit accumulation - FIXED VERSION
            if (computedData.maxProfit === "Unlimited") {
              hasUnlimitedProfit = true;
            } else if (computedData.maxProfit !== undefined && computedData.maxProfit !== null && typeof computedData.maxProfit === 'number') {
              totalMaxProfit += computedData.maxProfit;
            }
          }
        }
      }

      // Set final calculated values
      const finalMaxLoss = hasUnlimitedLoss ? "Unlimited" : totalMaxLoss;
      const finalMaxProfit = hasUnlimitedProfit ? "Unlimited" : totalMaxProfit;

      // Only update state if we processed items
      if (processedItems > 0) {
        setPotentialLoss(finalMaxLoss);
        setPotentialProfit(finalMaxProfit);
      }

    } else if (type === "strategy") {
      // Process strategy-based data
      for (let i = 0; i < group_data.length; i++) {
        let data = group_data[i];

        const ltp = await waitForLTP(data?.code, data?.exchange);

        if (ltp) {
          const computedData = metricsComputations.computeXandYAxis({
            selectedData: data?.positions,
            ltp: ltp,
            leastExpiry: null,
          });

          data.breakeven = computedData?.breakevenRange;
          let resp = calculatePointerPosition(
            computedData?.greenRange,
            computedData
          );
          data.greenBarWidth = resp?.width;
          data.leftSpace = resp?.leftSpace;
          data.pointerPosition = resp?.pointerPosition;
          data.x_axis = computedData?.x_axis;
          data.barType = resp?.barType;
          data.maxProfit = computedData?.maxProfit;
          data.maxLoss = computedData?.maxLoss;
          data.computedData = computedData;

          group_data[i] = data;
        }
      }
    }
  };

  useEffect(() => {
    let pendingProfit = 0;
    let totalPnl = 0;
    allPositions?.map((position, index) => {
      let ltp = symbolData[position?.code]?.ltp;
      if (ltp) {
        let pnl =
          parseFloat(position?.realised_pl) +
          (parseFloat(ltp) - parseFloat(position?.average_prc)) *
          parseFloat(position?.net_quantity);
        totalPnl = totalPnl + pnl;
      }
    });
    setNetProfit(totalPnl.toFixed(2));
    if (potentialProfit !== "Unlimited" && potentialProfit !== 0) {
      pendingProfit = potentialProfit - totalPnl;
      setPendingProfit(pendingProfit.toFixed(2));
      setAchievedPercent(((totalPnl / potentialProfit) * 100).toFixed(2));
    }
  }, [symbolData, potentialProfit, potentialLoss]);

  useLayoutEffect(() => {
    connectionEstablised = checkWebsocketConnection();
    if (connectionEstablised) {
      if (Object.keys(nsesubscribeSymbols).length !== 0) {
        subscribeToSymbols(nsesubscribeSymbols, "NSE");
      }
      if (Object.keys(nfosubscribeSymbols).length !== 0) {
        subscribeToSymbols(nfosubscribeSymbols, "NFO");
      }
      if (Object.keys(bsesubscribeSymbols).length !== 0) {
        subscribeToSymbols(bsesubscribeSymbols, "BSE");
      }
      if (Object.keys(bfosubscribeSymbols).length !== 0) {
        subscribeToSymbols(bfosubscribeSymbols, "BFO");
        // console.log("Subscribed to BFO symbols:", bfosubscribeSymbols);
      }
      if (Object.keys(mcxsubscribeSymbols).length !== 0) {
        subscribeToSymbols(mcxsubscribeSymbols, "MCX");
      }
      if (Object.keys(mcxunderlyingsubscribeSymbols).length !== 0) {
        subscribeToSymbols(mcxunderlyingsubscribeSymbols, "MCX");
      }
    }
  }, [
    nsesubscribeSymbols,
    nfosubscribeSymbols,
    bsesubscribeSymbols,
    bfosubscribeSymbols,
    mcxsubscribeSymbols,
    mcxunderlyingsubscribeSymbols
  ]);

  const handleButtonClick = (button) => {
    setActiveButton(button);
    setActiveTable(button);
    setExitButtonEnabled(isAnyCheckboxChecked);
  };

  const [isExitSelectedEnabledUnderlying, setIsExitSelectedEnabledUnderlying] =
    useState([false]);
  const [
    isExitSelectedEnabledExecutedStrategies,
    setIsExitSelectedEnabledExecutedStrategies,
  ] = useState([false]);

  const [isAnyCheckboxChecked, setIsAnyCheckboxChecked] = useState(false);

  const [exitButtonEnabled, setExitButtonEnabled] = useState(false);

  const handleCheckboxChange = (table, index, row_index) => {
    switch (table) {
      case "groupbyunderlying":
        setUnderlyingBased((prevPositions) => {
          const newPositions = [...prevPositions];
          newPositions[index].positions[row_index].selected =
            !newPositions[index].positions[row_index].selected;
          const isAnySelected = newPositions[index].positions.some(
            (position) => position.selected
          );
          setIsExitSelectedEnabledUnderlying((prevState) => {
            const newState = [...prevState];
            newState[index] = isAnySelected; // Toggle the boolean value
            return newState;
          });
          return newPositions;
        });
        break;
      case "executedstrategies":
        setStrategyBased((prevPositions) => {
          const newPositions = [...prevPositions];
          newPositions[index].positions[row_index].selected =
            !newPositions[index].positions[row_index].selected;
          const isAnySelected = newPositions[index].positions.some(
            (position) => position.selected
          );
          setIsExitSelectedEnabledExecutedStrategies((prevState) => {
            const newState = [...prevState];
            newState[index] = isAnySelected; // Toggle the boolean value
            return newState;
          });
          return newPositions;
        });
        break;
      default:
        break;
    }
  };

  const handleExitSelected = (table, index) => {
    switch (table) {
      case "groupbyunderlying":
        let selectedUnderlyingPositions = underlyingBased[index].positions
          .filter((position) => position.selected)
          .map((position) => ({
            ...position,
            ltp: symbolData[position.code]?.ltp,
          }));
        // console.log("live", selectedUnderlyingPositions);

        // Call exitPositions which will handle clearing selections
        exitPositions(selectedUnderlyingPositions);
        break;

      case "executedstrategies":
        let selectedSelectedPositions = strategyBased[index].positions
          .filter((position) => position.selected)
          .map((position) => ({
            ...position,
            ltp: symbolData[position.code]?.ltp,
          }));

        // Call exitPositions which will handle clearing selections
        exitPositions(selectedSelectedPositions);
        break;

      default:
        break;
    }
  };

  const handleOKClick = (location, index) => {
    const overlay = document.querySelector(".overlay");
    overlay.classList.remove("active");
    handleExitSelected(location, index);

    // Reset the selected position state
    setSelectedPosition({ location: null, index: null });
  };

  const [activeTable, setActiveTable] = useState("allpositions");

  const calculateLtpPointerPosition = (x_axis, ltp) => {
    try {
      const range =
        parseFloat(x_axis[x_axis?.length - 1]) - parseFloat(x_axis[0]);
      let ltpFromLeft = ltp - x_axis[0];
      let pointerPosition = (ltpFromLeft / range) * 100;
      return pointerPosition;
    } catch (e) {
      return 0;
    }
  };

  const calculatePointerPosition = (greenRange, item) => {
    if (item?.x_axis?.length > 0) {
      const range =
        parseFloat(item?.x_axis[item?.x_axis?.length - 1]) -
        parseFloat(item?.x_axis[0]);
      let barPosition;
      let greenBarWidth;
      let thumbWidthPercentage;
      let pointerPosition;
      let leftSpace;
      let barType;

      if (greenRange?.length == 2) {
        greenBarWidth = greenRange[1] - greenRange[0];
        barPosition = greenRange[0];
        thumbWidthPercentage = (greenBarWidth / range) * 100;
        barPosition = (greenRange[0] / item?.x_axis[0]) * 100;
        let leftDifference = greenRange[0] - item?.x_axis[0];
        leftSpace = (leftDifference / range) * 100;

        let ltp = symbolData[item?.code]?.ltp;
        let ltpFromLeft = ltp - item?.x_axis[0];
        pointerPosition = (ltpFromLeft / range) * 100;
        barType = "green";
      }
      if (greenRange?.length == 4) {
        greenBarWidth = greenRange[2] - greenRange[1];
        barPosition = greenRange[2];

        thumbWidthPercentage = (greenBarWidth / range) * 100;
        barPosition = (greenRange[1] / item?.x_axis[0]) * 100;
        let leftDifference = greenRange[1] - item?.x_axis[0];
        leftSpace = (leftDifference / range) * 100;

        let ltp = symbolData[item?.code]?.ltp;
        let ltpFromLeft = ltp - item?.x_axis[0];
        pointerPosition = (ltpFromLeft / range) * 100;
        barType = "red";
      }

      return {
        width: thumbWidthPercentage,
        leftSpace: leftSpace,
        pointerPosition: pointerPosition,
        barType: barType,
      };
    }
  };

  let totalFunds = fundsData.totalFunds;
  let utilisedFunds = fundsData.marginUtilized;
  let utilisedPercentage = 0;

  if (totalFunds !== 0) {
    utilisedPercentage = ((totalFunds - utilisedFunds) / totalFunds) * 100;
  }

  if (isNaN(utilisedPercentage)) {
    utilisedPercentage = 0;
  }

  // // console.log("utilised %", utilisedPercentage);
  const groupTables = document.querySelectorAll(".group-table");
  if (groupTables.length > 0) {
    const lastGroupTable = groupTables[groupTables.length - 1];
    lastGroupTable && lastGroupTable.classList.add("pb-4");
  }

  // removed simulated loading; using real fetching state instead

  return (
    <>
      <Helmet>
        <title>Positions</title>
      </Helmet>
      <div className="overlay"></div>

      <div className="flex mb-5 gap-3 mt-14 w-full">
        <div className="mb-3">
          <OverallCard
            netProfit={netProfit}
            pendingProfit={pendingProfit}
            achievedPercent={achievedPercent}
            potentialProfit={potentialProfit}
            potentialLoss={potentialLoss}
            fundsData={fundsData}
            utilisedPercentage={utilisedPercentage}
          />
          <div className="font-semibold text-sm text-p300 mt-4">Watchlist</div>
          <WatchlistContainer symbols={symbols} />
        </div>
        <div className="flex flex-col gap-3 grow min-w-0 w-full">
          <div className="flex justify-between">
            <div className="flex gap-3">
              <div className="tabs tabs-boxed bg-p400 rounded h-8 justify-between w-[314px] p-[1.7px] ">
                <div
                  className={`tab h-7 text-xs font-medium  rounded  ${activeButton === "groupbyunderlying"
                    ? "bg-n200 text-p300 font-semibold"
                    : "text-n500"
                    }`}
                  onClick={() => handleButtonClick("groupbyunderlying")}>
                  Group by Underlying
                </div>
                <div
                  className={`tab h-7 text-xs font-medium  ${activeButton === "executedstrategies"
                    ? "bg-n200 text-p300 font-semibold"
                    : "text-n500"
                    }`}
                  onClick={() => handleButtonClick("executedstrategies")}>
                  Executed Strategies
                </div>
              </div>
            </div>
          </div>

          {activeButton === "groupbyunderlying" && (
            <UnderlyingGroupView
              underlyingBased={underlyingBased}
              activeButton={activeButton}
              symbolData={symbolData}
              handleClick={handleClick}
              isExitSelectedEnabledUnderlying={isExitSelectedEnabledUnderlying}
              modalData={modalData}
              symbols={symbols}
              handleCallback={handleCallback}
              showToast={showToast}
              isFetching={isFetching}
              hadPositions={hadPositions}
              // handleHeaderCheckboxChange={handleHeaderCheckboxChange}
              handleRowMouseEnter={handleRowMouseEnter}
              handleRowMouseLeave={handleRowMouseLeave}
              hoveredRowIndex={hoveredRowIndex}
              mainIndex={mainIndex}
              visibility={visibility}
              duplicateData={duplicateData}
              // handleAddModal={handleAddModal}
              // handleExitModal={handleExitModal}
              handleCheckboxChange={handleCheckboxChange}
              formatNumberWithFontWeight={formatNumberWithFontWeight}
              calculateLtpPointerPosition={calculateLtpPointerPosition}
            />
          )}

          {activeButton === "executedstrategies" && (
            <ExecutedStrategiesView
              strategyBased={strategyBased}
              symbolData={symbolData}
              handleClick={handleClick}
              isExitSelectedEnabledExecutedStrategies={
                isExitSelectedEnabledExecutedStrategies
              }
              modalData={modalData}
              symbols={symbols}
              handleCallback={handleCallback}
              showToast={showToast}
              isFetching={isFetching}
              hadPositions={hadPositions}
              handleRowMouseEnter={handleRowMouseEnter}
              handleRowMouseLeave={handleRowMouseLeave}
              hoveredRowIndex={hoveredRowIndex}
              mainIndex={mainIndex}
              visibility={visibility}
              // handleAddModal={handleAddModal}
              // handleExitModal={handleExitModal}
              handleCheckboxChange={handleCheckboxChange}
              formatNumberWithFontWeight={formatNumberWithFontWeight}
            />
          )}
        </div>
      </div>
      <ConfirmStrategyModal
        isOpen={showConfirm}
        onCancel={() => {
          setShowConfirm(false);
        }}
        onConfirm={() => {
          setShowConfirm(false);
          handleOKClick(selectedPosition.location, selectedPosition.index);
        }}
      />
      <ReactTooltip
        id="potential-profit"
        place="top"
        variant={theme === "dark" ? "light" : "dark"}
        content="Maximum potential profit on the open positions until expiry."
      />
      <ReactTooltip
        id="potential-loss"
        place="top"
        variant={theme === "dark" ? "light" : "dark"}
        content="Maximum potential loss on the open positions until expiry."
      />
    </>
  );
};

export default PositionsDesktop;
